module.exports = __webpack_public_path__ + "static/media/10.fe349e85.jpeg";